<template>
    <div id="nature" class="wrap" v-if="natures">
        <h2 class="text-lg font-medium mb-5 uppercase text-secondary">NATURE DE L'INTERVENTION <span class="text-alert">*</span></h2>

        <div class="space-y-3">
            <!-- Intervention contractuelle -->
            <div>
                <input type="checkbox" id="type-intervention" v-model="natures.contractuel" @change="updateNatures"
                    class="sr-only peer" />
                <label for="type-intervention" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                   flex items-center justify-between">
                    <span>Intervention contractuelle</span>
                    <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                </label>
            </div>

            <!-- Description -->
            <textarea placeholder="Description de la demande" id="desc-demande" v-model="natures.description"
                @change="updateNatures" class="block w-full rounded-lg border border-gray-300 px-3 py-2"></textarea>

            <!-- Assemblage -->
            <div>
                <input type="checkbox" id="assemblage" value="1" v-model="natures.assemblage" @change="updateNatures"
                    class="sr-only peer" />
                <label for="assemblage" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                   flex items-center justify-between">
                    <span>Assemblage de l'équipement</span>
                    <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                </label>
            </div>

            <!-- Mise en service -->
            <div>
                <input type="checkbox" id="mise_en_service" value="1" v-model="natures.miseEnService"
                    @change="checkCtrl('miseEnService')" class="sr-only peer" />
                <label for="mise_en_service" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                   flex items-center justify-between">
                    <span>Mise en service de l'équipement</span>
                    <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                </label>
            </div>

            <!-- Modification -->
            <div>
                <input type="checkbox" id="modification" value="1" v-model="natures.modification"
                    @change="checkCtrl('modification')" ref="modif" class="sr-only peer" />
                <label for="modification" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                   flex items-center justify-between">
                    <span>Modification de l'équipement</span>
                    <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                </label>
            </div>

            <!-- Maintenance -->
            <div>
                <input type="checkbox" id="maintenance" value="1" v-model="natures.maintenance"
                    @change="checkCtrl('maintenance')" class="sr-only peer" />
                <label for="maintenance" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                   flex items-center justify-between">
                    <span>Maintenance de l'équipement</span>
                    <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                </label>
            </div>

            <!-- Contrôle périodique (si fluide) -->
            <div v-if="gotFluide">
                <input type="checkbox" id="controle_per" value="1" v-model="natures.controlePeriodique"
                    @change="updateNatures" class="sr-only peer" />
                <label for="controle_per" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                   flex items-center justify-between">
                    <span>Contrôle d'étanchéité périodique</span>
                    <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                </label>
            </div>

            <!-- Contrôle non périodique (si fluide) -->
            <div v-if="gotFluide">
                <input type="checkbox" id="controle_nonper" value="1" v-model="natures.controleNonPeriodique"
                    @change="updateNatures" class="sr-only peer" />
                <label for="controle_nonper" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                   flex items-center justify-between">
                    <span>Contrôle d'étanchéité non périodique</span>
                    <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                </label>
            </div>

            <!-- Démantèlement -->
            <div>
                <input type="checkbox" id="demantelement" value="1" v-model="natures.demantelement"
                    @change="updateNatures" class="sr-only peer" />
                <label for="demantelement" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                   flex items-center justify-between">
                    <span>Démantèlement</span>
                    <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                </label>
            </div>

            <!-- Rétrofit (si FIBSDD) -->
            <div v-if="isFibsdd">
                <input type="checkbox" id="retrofit" value="1" v-model="natures.retrofit" @change="retrofitCheck"
                    class="sr-only peer" />
                <label for="retrofit" class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                   flex items-center justify-between">
                    <span>Rétrofit</span>
                    <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                </label>
            </div>

            <!-- Nouveau fluide (si rétrofit) -->
            <div v-show="natures.retrofit" class="space-y-2">
                <label class="label">Nouveau fluide</label>
                <select v-model="natures.newFluide" @change="updateNatures"
                    class="block w-full rounded-lg border border-gray-300 px-3 py-2 bg-white">
                    <option selected disabled>Sélectionnez un fluide</option>
                    <option v-for="fluide in fluides" :key="fluide.id" :value="fluide.id">
                        {{ fluide.nom }}{{ (fluide.nom_commercial) ? ' - ' + fluide.nom_commercial : '' }}
                    </option>
                </select>
            </div>

            <!-- Autre -->
            <input type="text" class="block w-full rounded-lg border border-gray-300 px-3 py-2"
                placeholder="Autre ( 50 caractères max. )" maxlength="50" name="intervention_autre"
                v-model="natures.autres" @change="updateNatures" />

            <!-- Observations (si FIBSDD) -->
            <textarea v-if="isFibsdd" name="nature_observation" id="observations" placeholder="Observations sur cerfa"
                class="block w-full rounded-lg border border-gray-300 px-3 py-2" v-model="natures.observations"
                @change="updateNatures" maxlength="115"></textarea>
        </div>

        <a href="javascript: void 0" id="next-start" class="btn-primary next mt-4" @click="next">
            INTERVENIR
            <i class="icon-go"></i>
        </a>
    </div>
</template>


<script>
import Fluide from '../../../../js/models/Fluide'

export default {
    data() {
        return {
            fluides: null
        }
    },
    props: {
        natures: {
            assemblage: false,
            miseEnService: false,
            modification: false,
            maintenance: false,
            controlePeriodique: false,
            controleNonPeriodique: false,
            demantelement: false,
            retrofit: false,
            newFluide: null,
            autres: null,
            observations: null,
            description: null,
            contractuel: null,
        },
        gotFluide: null,
        isFibsdd: null
    },
    mounted() {
        this.fetchFluides()
    },
    methods: {
        checkCtrl() {
            if ((this.natures.modification || this.natures.miseEnService || this.natures.maintenance) && this.gotFluide) {
                this.natures.controleNonPeriodique = true
            }
            this.updateNatures()
        },
        fetchFluides() {
            let fluide = new Fluide;
            fluide.getList(data => this.fluides = data.filter(f => !f.regenerated))
        },
        retrofitCheck() {
            this.natures.newFluide = null;
            if (this.natures.retrofit === true) {
                this.natures.controleNonPeriodique = true;
                this.natures.modification = true
            }
            this.updateNatures()
        },
        updateNatures() {
            this.$emit('natureUpdated', this.natures)
        },
        next() {

            let errors = [];

            if (this.natures.retrofit === true && this.natures.newFluide === null) {
                errors.push('Veuillez sélectionner le nouveau fluide suite au rétrofit')
            }

            let naturesRequired = this.natures;
            let countSelected = 0;

            for (let nature in naturesRequired) {
                if (nature !== 'observations' && nature !== 'newFluide' && nature !== 'contractuel' && nature !== "description") {
                    if (naturesRequired[nature] !== null && naturesRequired[nature] !== '' && naturesRequired[nature] !== false) {
                        countSelected++
                    }
                }
            }

            if (countSelected === 0) {
                errors.push('Veuillez indiquer la nature de votre intervention')
            }

            if (errors.length === 0) {
                this.$emit('goToIntervention');
                this.$emit('natureUpdated', this.natures)
            } else {
                swal('Erreur', errors[0], 'warning')
            }

        },
    }
}
</script>



// WEBPACK FOOTER //
// Nature.vue?1acddd62